module.exports = __webpack_public_path__ + "static/media/orencash1.75249e1d.jpg";